import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a7b2cdfbedae70014f45e43_1787677142926_fc469d6f/doctordashboard/src/app/ToasterProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a7b2cdfbedae70014f45e43_1787677142926_fc469d6f/doctordashboard/src/styles/tailwind.css");
